import { api } from './api';

/**
 * Logs in the user (admin) and returns the JWT token.
 * @param username - the admin username (or email if backend expects email)
 * @param password - the password
 */
export const login = async (username: string, password: string): Promise<string> => {
    // Your backend expects email and password (adjust if using username)
    const response = await api.post('/auth/login', {
        email: username, // Change to "username" if your backend expects "username"
        password,
    });
    return response.data.token;
};

/**
 * Removes JWT token from localStorage and handles logout.
 */
export const logout = () => {
    localStorage.removeItem('jwtToken');
    window.location.href = "/login";
};

/**
 * Retrieves the stored JWT token for external service authentication.
 */
export const getAccessToken = (): string | null => {
    return localStorage.getItem('jwtToken');
};